module.exports = __webpack_public_path__ + "media/crypto/btcln-36c0730d.png";